import { Box, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import { ConflictResponse, UserRole } from '../../../generated'
import { CustomPagination } from '../common/CustomPagination'
import { StickyTable } from '../common/StickyTable'
import { TableSkeleton } from '../skeletons/TableSkeleton'
import { NOT_APPLICABLE } from '../../constants'
import { formatPhone, titleize } from '../../utils'
import { Link } from 'react-router-dom'
import { ConflictTableHeaders } from '../../constants'

const ConflictListings = ({ conflicts, loading }: { conflicts: ConflictResponse['conflicts']; loading: boolean }) => {
  return (
    <Box my={3}>
      <StickyTable pagination={<CustomPagination loading={false} />} height="405px">
        <TableHead>
          <TableRow hover>
            {ConflictTableHeaders.map((header, index) => (
              <TableCell key={index} component="th" align="left">
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        {loading ? (
          <TableSkeleton noOfRows={3} noOfCols={ConflictTableHeaders.length} />
        ) : (
          <TableBody>
            {conflicts.map(conflict => {
              const { contact, role, caseRole, case: cases } = conflict
              const { addresses } = contact
              const { caseToUsers } = cases ?? {}
              const address = addresses?.[0]
              const attorney = caseToUsers?.filter(
                attorneyUser => attorneyUser?.user?.roles && attorneyUser?.user?.roles[0]?.role === UserRole.Attorney
              )

              return (
                <TableRow key={conflict.contact.id}>
                  <TableCell>
                    <Box>
                      <Typography variant="body1" noWrap>
                        {contact.firstName || NOT_APPLICABLE} {contact.middleName} {contact.lastName} {contact.suffix}
                      </Typography>

                      <Typography variant="subtitle1" noWrap>
                        Work Phone: {formatPhone(contact.phoneNumber || NOT_APPLICABLE)}
                      </Typography>

                      <Typography variant="subtitle1" noWrap>
                        Email: {contact.email || NOT_APPLICABLE}
                      </Typography>

                      <Typography variant="subtitle1" noWrap>
                        Business Name: {contact.businessName || NOT_APPLICABLE}
                      </Typography>

                      <Typography variant="subtitle1" noWrap>
                        {[address?.address1, address?.address2, address?.city, address?.state, address?.zipCode]
                          .filter(Boolean)
                          .join(', ')}
                      </Typography>
                    </Box>
                  </TableCell>

                  <TableCell>
                    <Box>
                      <Link to={cases?.id ? `/matters/matter-detail/${cases?.id}` : ''}>
                        <Typography variant="subtitle1" color={cases?.id ? 'primary' : 'black'} noWrap>
                          {cases?.id ? `(#${cases?.caseNumber})` : NOT_APPLICABLE} {cases?.title}
                        </Typography>
                      </Link>
                    </Box>
                  </TableCell>

                  <TableCell>
                    <Typography variant="body1" noWrap>
                      {titleize(caseRole ?? role) || NOT_APPLICABLE}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography variant="body1" noWrap>
                      {!caseToUsers?.length
                        ? NOT_APPLICABLE
                        : attorney?.map(attorn => attorn?.user?.firstName + ' ' + attorn?.user?.lastName).join(', ')}
                    </Typography>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        )}
      </StickyTable>
    </Box>
  )
}

export default ConflictListings
